<template>
  <Panel
    :class="'panel-participants'"
    :variant="['30-paddings', 'default', 'rounded']"
  >
    <Subheader
      :text="$t('_web_tournaments_list_participants', 'Participants')"
      class="tournament-settings-wrapper__title mb-5"
    />
    <div class="row tournament-quantity">
      <TournamentSquadsSetting />
    </div>
    <div class="row squad-management">
      <div class="col-auto row tournament-squad-size">
        <TournamentSquadSizeSetting />
      </div>
      <div class="col-auto tournament-substitute">
        <TournamentSubstitutesSetting />
      </div>
      <div class="col-auto tournament-roster-size">
        <TournamentFullTeamSizeInfo />
      </div>
      <div class="col-3 tournament-roster-size">
        <TournamentSettingsRequireFullTeams />
      </div>
    </div>
    <div class="row mt-5 qualification-type">
      <TournamentSettingQualificationType />
    </div>
  </Panel>
</template>

<script>
import { translate } from '@/mixins/translate';
import TournamentSquadSizeSetting from '@/views/tournaments/management/singleTournament/components/SettingsSquadSize';
import TournamentSquadsSetting from '@/views/tournaments/management/singleTournament/components/SettingsSquads';
import TournamentSubstitutesSetting from '@/views/tournaments/management/singleTournament/components/SettingsSubstitutesCount';
import TournamentFullTeamSizeInfo from '@/views/tournaments/management/singleTournament/components/SettingsFullTeamSize';
import TournamentSettingQualificationType from '@/views/tournaments/management/singleTournament/components/SettingsQualificationType';
import TournamentSettingsRequireFullTeams from '@/views/tournaments/management/singleTournament/components/SettingsRequireFullTeams.vue';

import Panel from '@/components/atoms/Panel';
import Subheader from '@/components/atoms/Subheader';
export default {
  name: 'ParticipantsSection',
  components: {
    Panel,
    Subheader,
    TournamentSquadSizeSetting,
    TournamentSquadsSetting,
    TournamentSubstitutesSetting,
    TournamentFullTeamSizeInfo,
    TournamentSettingQualificationType,
    TournamentSettingsRequireFullTeams,
  },
  mixins: [translate('_web_tournament_settings')],
};
</script>

<style lang="scss">
.panel-participants {
  padding-top: 20px !important;
}

.tournament-settings-wrapper__title span {
  font-size: $hr-heading-5 !important;
}

.tournament-quantity .playhera-label {
  padding-bottom: 10px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.tournament-quantity .input-form {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
}

.tournament-quantity .multi-radio {
  margin-bottom: 20px;
}

.multi-radio-input-border :focus {
  border: 2px solid $hr-bg-accent;
}

.tournament-squad-size .playhera-label {
  padding-bottom: 10px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.tournament-substitute .playhera-label {
  padding-bottom: 10px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.tournament-substitute input {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
}

.tournament-substitute input :focus {
  border: 2px solid $hr-bg-accent;
}

.substitutes-count-input label {
  padding-bottom: 10px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.substitutes-count-input input {
  background-color: $hr-bg-header;
}

.qualification-type .playhera-label {
  padding-bottom: 20px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.qualification-type .segment-control-btn {
  background-color: $hr-bg-header;
  margin-bottom: 20px !important;
}

.qualification-type .wrapper-control {
  padding-bottom: 10px;
}

.squad-management {
  padding-bottom: 20px;
  gap: 40px;
}
</style>
